import { create } from 'zustand';

interface DoBoxLeftTaskGroupStore {
  leftTaskGroupId: string | null;
  markLeft: (taskGroupId: string) => void;
  clearLeft: () => void;
}

export const useDoBoxLeftTaskGroupStore = create<DoBoxLeftTaskGroupStore>(
  (set) => ({
    leftTaskGroupId: null,
    markLeft: (taskGroupId) => set({ leftTaskGroupId: taskGroupId }),
    clearLeft: () => set({ leftTaskGroupId: null }),
  }),
);
